import Cookie from 'js-cookie'
import defaultSettings from '@/settings'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'

/* 中英文 */
const language = Cookie.get('language') || 'zh'
const isZh = language === 'zh'

const { showSettings, tagsView, fixedHeader, sidebarLogo, theme, openMsgNotify, colorType } = defaultSettings
const colorSettings = [
  { colorKey: '0', colorName: '正操作', colorEnglishName: 'Operating', colorValue: '#FFFFCC' },
  { colorKey: '11', colorName: '预提交', colorEnglishName: 'Pre Commit', colorValue: '#999933' },
  { colorKey: '13', colorName: '提交中', colorEnglishName: 'Committing', colorValue: '#FFFF00' },
  { colorKey: '1', colorName: '已提交', colorEnglishName: 'Committed', colorValue: '#33FF66' },
  { colorKey: '2', colorName: '已审核', colorEnglishName: 'Verified', colorValue: '#6699CC' },
  { colorKey: '3', colorName: '已退关', colorEnglishName: 'Shut Out', colorValue: '#00CCCC' },
  { colorKey: 'isBlocked', colorName: '已锁定', colorEnglishName: 'Locked', colorValue: '#CCFFFF' }]
const financeColorSettings = [
  { colorKey: '1', colorName: '应收全部核销', colorEnglishName: 'Full Receivable Write-off', colorValue: '#00B050' },
  { colorKey: '2', colorName: '应收部分核销', colorEnglishName: 'Partial Receivable Write-off', colorValue: '#92D050' },
  { colorKey: '3', colorName: '未录应收', colorEnglishName: 'Unrecorded Receivable', colorValue: '#F52B40' },
  { colorKey: '4', colorName: '应收未开票', colorEnglishName: 'Receivable Not Invoiced', colorValue: '#EF949F' },
  { colorKey: '5', colorName: '应收部分开票', colorEnglishName: 'Receivable Partially Invoiced', colorValue: '#F7F2B9' },
  { colorKey: '6', colorName: '应收全部开票', colorEnglishName: 'Receivable Fully Invoiced', colorValue: '#FFF885' }
]
const partnerLabelSettings = [
  { autoKey: 'auto_0', autoName: '客户/委托单位', autoEnglishName: 'Client/Customer', englishName: !isZh, chineseName: isZh, sortNamePlusEnglishName: false, sortNamePlusChineseName: false, code: false, shortName: false, shortNamePlusChineseName: false, customerNoChineseName: false },
  { autoKey: 'auto_1', autoName: '订舱代理/换单代理', autoEnglishName: 'Booking Agent', englishName: !isZh, chineseName: isZh, sortNamePlusEnglishName: false, sortNamePlusChineseName: false, code: false, shortName: false, shortNamePlusChineseName: false, supplierNoChineseName: false },
  { autoKey: 'auto_2', autoName: '目的港代理', autoEnglishName: 'Dest. Agent', englishName: true, chineseName: false, sortNamePlusEnglishName: false, sortNamePlusChineseName: false, code: false, shortName: false, shortNamePlusChineseName: false, supplierNoChineseName: false },
  { autoKey: 'auto_3', autoName: '指定货代理', autoEnglishName: 'Nomination Cargo Agent', englishName: true, chineseName: false, sortNamePlusEnglishName: false, sortNamePlusChineseName: false, code: false, shortName: false, shortNamePlusChineseName: false, supplierNoChineseName: false },
  { autoKey: 'auto_4', autoName: '本地代理', autoEnglishName: 'Local agent', englishName: !isZh, chineseName: isZh, sortNamePlusEnglishName: false, sortNamePlusChineseName: false, code: false, shortName: false, shortNamePlusChineseName: false, supplierNoChineseName: false },
  { autoKey: 'auto_5', autoName: '船公司', autoEnglishName: 'Shipping Company', englishName: !isZh, chineseName: isZh, sortNamePlusEnglishName: false, sortNamePlusChineseName: false, code: false, shortName: false, shortNamePlusChineseName: false },
  { autoKey: 'auto_6', autoName: '航空公司', autoEnglishName: 'Airline', englishName: false, chineseName: false, sortNamePlusEnglishName: !isZh, sortNamePlusChineseName: isZh, code: false, shortName: false, shortNamePlusChineseName: false, threeCharacterCode: false },
  { autoKey: 'auto_7', autoName: '海运港口', autoEnglishName: 'Seaport', englishName: true, chineseName: false, sortNamePlusEnglishName: false, sortNamePlusChineseName: false, code: false }, // 默认显示英文
  { autoKey: 'auto_8', autoName: '空运港口', autoEnglishName: 'Airport', englishName: true, chineseName: false, sortNamePlusEnglishName: false, sortNamePlusChineseName: false, code: false }, // 默认显示中文
  { autoKey: 'auto_railway', autoName: '铁路站点', autoEnglishName: 'Railway Station', englishName: true, chineseName: false, sortNamePlusEnglishName: false, sortNamePlusChineseName: false, code: false }, // 默认显示中文
  { autoKey: 'auto_paymentTerm', autoName: '运费条款', autoEnglishName: 'Payment Term', name: true, code: false, codePlusName: false, localName: false },
  { autoKey: 'auto_9', autoName: '报关行', autoEnglishName: 'Customs Broker', englishName: !isZh, chineseName: isZh, sortNamePlusEnglishName: false, sortNamePlusChineseName: false, code: false, shortName: false, shortNamePlusChineseName: false, supplierNoChineseName: false },
  { autoKey: 'auto_10', autoName: '仓库', autoEnglishName: 'Warehouse', englishName: !isZh, chineseName: isZh, sortNamePlusEnglishName: false, sortNamePlusChineseName: false, code: false, shortName: false, shortNamePlusChineseName: false, supplierNoChineseName: false },
  { autoKey: 'auto_11', autoName: '卡车公司', autoEnglishName: 'Trucker', englishName: !isZh, chineseName: isZh, sortNamePlusEnglishName: false, sortNamePlusChineseName: false, code: false, shortName: false, shortNamePlusChineseName: false, supplierNoChineseName: false },
  /* { autoKey: 'auto_12', autoName: '集团公司', englishName: !isZh, chineseName: isZh, sortNamePlusEnglishName: false, sortNamePlusChineseName: false, code: false, shortName: false },*/
  { autoKey: 'auto_op', autoName: '操作', autoEnglishName: 'OP', englishName: !isZh, chineseName: isZh, sortNamePlusEnglishName: false, sortNamePlusChineseName: false, chineseNamePlusEnglishName: false, englishNamePlusChineseName: false },
  { autoKey: 'auto_sales', autoName: '销售', autoEnglishName: 'Sales', englishName: !isZh, chineseName: isZh, sortNamePlusEnglishName: false, sortNamePlusChineseName: false, chineseNamePlusEnglishName: false, englishNamePlusChineseName: false },
  { autoKey: 'auto_csr', autoName: '客服', autoEnglishName: 'CS', englishName: !isZh, chineseName: isZh, sortNamePlusEnglishName: false, sortNamePlusChineseName: false, chineseNamePlusEnglishName: false, englishNamePlusChineseName: false },
  /* { autoKey: 'auto_14', autoName: '船名', englishName: true, chineseName: false, sortNamePlusEnglishName: false, sortNamePlusChineseName: false, code: false, shortName: false },*/
  { autoKey: 'auto_shipper', autoName: '发货人', autoEnglishName: 'Shipper', englishName: true, chineseName: false, sortNamePlusEnglishName: false, sortNamePlusChineseName: false, code: false, shortName: false, shortNamePlusChineseName: false },
  { autoKey: 'auto_consignee', autoName: '收货人', autoEnglishName: 'Consignee', englishName: true, chineseName: false, sortNamePlusEnglishName: false, sortNamePlusChineseName: false, code: false, shortName: false, shortNamePlusChineseName: false },
  { autoKey: 'auto_notify', autoName: '通知人', autoEnglishName: 'Notify', englishName: true, chineseName: false, sortNamePlusEnglishName: false, sortNamePlusChineseName: false, code: false, shortName: false, shortNamePlusChineseName: false },
  { autoKey: 'auto_accountId', autoName: '结算对象/结算代理', autoEnglishName: 'Settlement object/settlement agent', englishName: !isZh, chineseName: isZh, sortNamePlusEnglishName: false, sortNamePlusChineseName: false, code: false, shortName: false, shortNamePlusChineseName: false, customerSupplierNoChineseName: false },
  /* { autoKey: 'auto_15', autoName: '其他', englishName: !isZh, chineseName: isZh, sortNamePlusEnglishName: false, sortNamePlusChineseName: false, code: false, shortName: false },
  // CARGO-7863 操作分公司和销售分公司
  { autoKey: 'auto_opOffice', autoName: '操作分公司', englishName: !isZh, chineseName: isZh, sortNamePlusEnglishName: false, sortNamePlusChineseName: false, code: false, shortName: false },
  { autoKey: 'auto_salesOffice', autoName: '销售分公司', englishName: !isZh, chineseName: isZh, sortNamePlusEnglishName: false, sortNamePlusChineseName: false, code: false, shortName: false }*/
  { autoKey: 'auto_office', autoName: '所属分公司', autoEnglishName: 'Owned Branch', chineseName: false, englishName: false, code: true }
]
const imperialSettings = [
  {
    key: 'ae', name: '空运出口', englishName: 'Air export', children: [
      { key: 'ae_1', name: '空运订舱', englishName: 'Air Booking', imperial: false },
      { key: 'ae_2', name: '远程订舱', englishName: 'Remote booking', imperial: false },
      { key: 'ae_3', name: '前置仓收货', englishName: 'Pre-distribution center receiving', imperial: false },
      { key: 'ae_4', name: '待入库清单', englishName: 'Pending inbound list', imperial: false },
      { key: 'ae_5', name: '仓储', englishName: 'Warehouse storage', imperial: false },
      { key: 'ae_6', name: '前置仓出库', englishName: 'Pre-distribution center outbound', imperial: false }
    ]
  }
]

const state = {
  theme: theme,
  showSettings: showSettings,
  env: process.env.VUE_APP_ENV,
  version: process.env.VUE_APP_VERSION,
  isProd: ['prod'].includes(process.env.VUE_APP_ENV),
  tagsView: tagsView,
  fixedHeader: fixedHeader,
  sidebarLogo: sidebarLogo,
  openMsgNotify: openMsgNotify,
  colorType: colorType,
  colorSettings: colorSettings,
  financeColorSettings: financeColorSettings,
  partnerLabelSettings: partnerLabelSettings,
  imperialSettings: imperialSettings,
  ownedBranchStyle: 'list',
  isUIPersonalized: false,
  settingAndToolsVisible: false,
  tempBranchId: 0,
  rateCacheRange: 0,
  bsLimitInfo: { // 计费限制信息
    branchCountLimited: false,
    initBranchCount: 0,
    validBranchCount: '',
    userCountLimited: false,
    initUserCount: 0,
    validUserCount: 0,
    crmInvalidDate: '',
    biInvalidDate: '',
    financeInvalidDate: '',
    ediInvalidDate: '',
    RJTaxInvalidDate: '',
    BWTaxInvalidDate: '',
    NNTaxInvalidDate: '',
    HTTaxInvalidDate: ''
  }
}

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  }
}

const actions = {
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  },
  setOwnedBranchStyle({ commit }, value) {
    commit('CHANGE_SETTING', { key: 'ownedBranchStyle', value })
    LocalStorageUtilsNew.setConfiguration('ownedBranchStyle', value)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
